import { lazy } from 'react';
import Footer from '@alltrails/shared/components/Footer';
import QuoteRotator from 'components/QuoteRotator';
import AlgoliaSearchBox from '../components/AlgoliaSearchBox';
import UpdatePaymentForm from '../components/forms/UpdatePaymentForm';
import Navigation from '../components/Navigation';
import MobileHeader from '../components/MobileHeader';
import MobileHomeLink from '../components/NavigationDrawer/MobileHomeLink';
import ProPage from '../pages/ProPage';
import HomePage from '../pages/HomePage';
import SearchApp from '../components/SearchApp';
import { GiftFlow } from '../components/GiftFlow/GiftFlow/GiftFlow';
import GlobalActions from '../components/GlobalActions';
import { MobileRoadblock } from '../application/javascripts/react_components/branch/mobile_roadblock';
import LoginForm from '../components/forms/LoginForm';
import ProfileSlidingTabs from '../components/profile/ProfileSlidingTabs';
import RedemptionPage from '../components/RedemptionPage';
import SignUpForm from '../components/forms/SignUpForm';
import withSuspense from '../hocs/withSuspense';

const Mobile = lazy(() => import('../pages/Mobile'));

require('@alltrails/shared/dist/index.css');

const ReactRailsUJS = require('react_ujs');

const context = {
  AlgoliaSearchBox,
  Mobile: withSuspense(Mobile, 'Mobile'),
  UpdatePaymentForm,
  GiftFlow,
  GlobalActions,
  HomePage,
  Footer,
  LoginForm,
  SearchApp,
  MobileRoadblock,
  MobileHomeLink,
  Navigation,
  MobileHeader,
  ProPage,
  QuoteRotator,
  RedemptionPage,
  ProfileSlidingTabs,
  SignUpForm
};

ReactRailsUJS.getConstructor = className => {
  return context[className];
};
